(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('CheckoutInvestmentAgreements', [
			'$document',
			'CheckoutFactory',
			'globalConfig',
			CheckoutInvestmentAgreementsFunction
		]);
	
	function CheckoutInvestmentAgreementsFunction(
		$document,
		CheckoutFactory,
		globalConfig
	) {
		
		var checkoutInvestmentAgreements = this;
		
		checkoutInvestmentAgreements.$onInit = function() {
			angular.extend(checkoutInvestmentAgreements, globalConfig);

			CheckoutFactory.getDocumentsAndAgreements(checkoutInvestmentAgreements.orderGroupId)
				.then(function(response) {
					angular.extend(checkoutInvestmentAgreements, response);
					checkoutInvestmentAgreements.formReady = true;
				})
				.catch(function() {
					checkoutInvestmentAgreements.multiReitAcknowledgmentForm.$setValidity('documentLoadError', false);
				});
		};		
	}
})(window.angular);